/**
 * The legal/support links, in one place because two chromes render them: the
 * hamburger in SiteHeader (the customer- and prescriber-facing surfaces) and the
 * link row in SiteFooter (marketing, the embedded Shopify app). They drifted the
 * moment they were declared twice, so they aren't.
 *
 * A plain `.ts` constants module rather than a colocated export from either
 * component: both import it, and a shared value that a route COMPONENT reads
 * must not be reachable only through a module with its own render-time deps.
 */
export const siteNav = [
	{ to: '/privacy', label: 'Privacy' },
	{ to: '/tos', label: 'Terms' },
	{ to: '/support', label: 'Support' },
] as const
